const AlertIcon = ({
  width = '37px',
  height = '37px',
  fill = '#EF3E42',
}: {
  width?: string
  height?: string
  fill?: string
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 37 37'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Group 20</title>
    <desc>Created with Sketch.</desc>
    <g id='Tag-Manager' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Artboard' transform='translate(-1845.000000, -75.000000)'>
        <g id='Group-3-Copy-4' transform='translate(1659.000000, 48.000000)'>
          <g id='Group-20' transform='translate(186.000000, 27.000000)'>
            <g id='noun_23235_cc-copy' fillRule='nonzero'>
              <path
                d='M18.5,0 C8.28260417,0 0,8.28260417 0,18.5 C0,28.7173958 8.28260417,37 18.5,37 C28.7173958,37 37,28.7173958 37,18.5 C37,8.28260417 28.7173958,0 18.5,0 Z'
                id='Shape'
                fill={fill}
              ></path>
              <path
                d='M18.493,8.00079641 C19.6082456,8.00079641 20.6390228,8.59495223 21.198,9.56 L28.078,21.434 C28.6393076,22.4004195 28.6412134,23.5931626 28.0829969,24.5613709 C27.5247804,25.5295792 26.4916004,26.1255479 25.374,26.124003 L11.624,26.124003 C10.5074492,26.1230652 9.47617087,25.5266654 8.91847895,24.5593669 C8.36078702,23.5920684 8.36136681,22.4007552 8.92,21.434 L15.788,9.56 C16.3469772,8.59495223 17.3777544,8.00079641 18.493,8.00079641 Z M18.5,9.562 C17.942448,9.5641059 17.4278394,9.86175672 17.148,10.344 L10.272,22.218 C9.99252877,22.7012328 9.99218379,23.296877 10.2710951,23.7804332 C10.5500064,24.2639895 11.0657723,24.562 11.624,24.562 L25.374,24.562 C25.9322277,24.562 26.4479936,24.2639895 26.7269049,23.7804332 C27.0058162,23.296877 27.0054712,22.7012328 26.726,22.218 L19.846,10.344 C19.5669489,9.86389069 19.0552954,9.5666299 18.5,9.562 Z M18.5,20.8 C18.9318867,20.8 19.282,21.1501133 19.282,21.582 C19.282,22.0138867 18.9318867,22.364 18.5,22.364 C18.0681133,22.364 17.718,22.0138867 17.718,21.582 C17.718,21.1501133 18.0681133,20.8 18.5,20.8 Z M18.9013615,13.9299212 C19.1490199,14.0785292 19.2946018,14.3515458 19.28,14.64 L19.28,18.624 C19.2777988,19.0532192 18.9292248,19.4 18.5,19.4 C18.0681133,19.4 17.718,19.0498867 17.718,18.618 L17.718,14.64 C17.7033982,14.3515458 17.8489801,14.0785292 18.0966385,13.9299212 C18.344297,13.7813132 18.653703,13.7813132 18.9013615,13.9299212 Z'
                id='Combined-Shape'
                stroke='#FFFFFF'
                fill='#FFFFFF'
              ></path>
            </g>
            <g id='noun_Warning_2757567' transform='translate(8.500000, 8.000000)'>
              <g id='Group'></g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default AlertIcon
